import { Input, Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { IUser } from '../models/IUser';
import { MenuItem } from 'primeng/components/common/menuitem';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrls: ['./auth-header.component.scss']
})

export class AuthHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() showMenu: boolean;
  user: IUser;
  items: [MenuItem];

  constructor(private userService: UserService, private authService: AuthService) { }

  ngOnInit() {
    this.user = this.userService.user;
    this.items = [{icon: 'fa fa-sign-out', label: 'Logout', command: this.logout}];
  }

  private logout = () => this.authService.logout();
}
